import React, { FC, ReactNode } from "react"; 
import { CustomLabel, FlexContainer, UtilityMethods } from "@mindmemobile/mm-shared-global";
import { ItemCard } from "../../../shared/components";
import { RelatedItemsModel, RelatedSectionModel } from "../../../shared/models";


type IProps = {
  relatedSectionData: RelatedSectionModel | null;
};

const PurchaseLinkRelatedItems: FC<IProps> = ({ relatedSectionData }) => {
  if (!relatedSectionData) return null;

  const showItems = (data: RelatedItemsModel) => {
      return data.showAccountCredits || data.showCategories || data.showSelectItems;
  };

  const getCategories = (data: RelatedItemsModel) => {
      return data.categories.map((category) => category.name);
  };

  const renderSection = (title: string, data: RelatedItemsModel, label: string | ReactNode) => {
      if (!data || !showItems(data)) return null;

      return (
          <FlexContainer fxLayout="column" spacing={5}>
              <CustomLabel fontWeight={'600'} fontSize={'18px'}>
                  {title}
              </CustomLabel>
              <CustomLabel fontSize={'12px'}>{label}</CustomLabel>
              <div className="pl-rendered-section">
                  {data.showSelectItems && (
                      <FlexContainer spacing={10}>
                          {data.items.map((item, idx) => {
                              const itemData = item.medias.length > 0 ? item.medias[0] : null;
                              return (
                                  <ItemCard
                                      key={idx}
                                      url={itemData?.fullURL || ''}
                                      mediaType={itemData?.type || ''}
                                      label={item.name}
                                      price={item.priceDisplay}
                                      subLabel={
                                          item.prices
                                              .filter((x) => item.selectedPriceIds.includes(x.id))
                                              ?.map((x) => x.name)
                                              ?.join() || ''
                                      }
                                      showDeleteIcon={false}
                                      onClick={() => {}}
                                      showOverlay={false}
                                  />
                              );
                          })}
                      </FlexContainer>
                  )}
                  {data.showAccountCredits && (
                      <FlexContainer spacing={20}>
                          <CustomLabel>Account Credit:</CustomLabel>
                          <CustomLabel>
                              {' '}
                              <span className="semi-bold"> ${data.accountCredits}</span> USD
                          </CustomLabel>
                      </FlexContainer>
                  )}
                  {data.showCategories && (
                      <FlexContainer spacing={20} alignItems="center">
                          <CustomLabel>Items in Categories:</CustomLabel>
                          <FlexContainer spacing={10}>
                              {getCategories(data).map((category) => (
                                  <CustomLabel
                                      key={category}
                                      fontWeight={'bold'}
                                      style={{ border: '1px solid black', padding: '10px' }}
                                  >
                                      {category}
                                  </CustomLabel>
                              ))}
                          </FlexContainer>
                      </FlexContainer>
                  )}
              </div>
          </FlexContainer>
      );
  };

  return (
      <FlexContainer fxLayout="column" spacing={30}>
          {renderSection(
              'Included',
              relatedSectionData.includedItems,
              <p>
                  This will be included at <b>no cost</b> when this item is purchased
              </p>,
          )}
          {renderSection(
              'Required',
              relatedSectionData.requiredItems,
              <p>
                  <b>{UtilityMethods.numberToWord(relatedSectionData.requiredItems.totalRequired)}</b>
                  {` of these items will be `}
                  <b>required</b> to purchase when the item is purchased
              </p>,
          )}
          {renderSection(
              'Recommended',
              relatedSectionData.recommendedItems,
              <p>
                  This will be <b>recommended</b> when the item is purchased
              </p>,
          )}
      </FlexContainer>
  );
};

export default PurchaseLinkRelatedItems;
